import React from 'react'

const color = {
    color: '#828282',
    background: '#828282',
}

const rank = {
    borderRadius: '2.5px',
    opacity: '25%',
}

const title = {
    opacity: '50%',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
}

const link = {
    opacity: '10%',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
}

const details = {
    opacity: '10%',
    borderRadius: '2.5px',
}

const lineGenerator = n => {
    const length = Math.floor((Math.random() * n) + 1)
    let line = ""
    for (let i = 0; i < length; i++) {
        line += "_"
    }
    return line
}

const LoadingSkeleton = () => {
    const array = [];

    for (let i = 0; i < 30; i ++) {
        array.push(
            <div className="flex mt2 items-start" key={i}>
                <div className="flex justify-between link-nr">
                    <span style={{...color, ...rank}}>__</span>
                    
                     <span className="ml1 gray f11 upvote">▲</span>
        
                </div>
                <div className="ml1">
                    <span style={{...color, ...title}}>
                        {lineGenerator(100)}
                    </span>
                    {" "}
                    <span className="f12 gray" style={{...color, ...link}}>
                        {lineGenerator(25)}
                    </span>
                    <div className="f8pt lh-copy gray mt1 ls-m">
                        <span style={{...color, ...details}}>________</span>
                        <span> | </span>
                        <span  style={{...color, ...details}}>__</span>
                        <span  style={{...color, ...details}}>
                            {lineGenerator(10)}
                        </span>
                        <span  style={{...color, ...details}}>________</span>
                        <span> | </span>
                        <span  style={{...color, ...details}}>_ ________</span>
                    </div>
                </div>
            </div>
        )
    }

    return array
}

export default LoadingSkeleton



// WEBPACK FOOTER //
// ./src/components/LoadingSkeleton.js